// Element Plus 格式的日期范围快捷选项
// 用于日期范围选择器（daterange 类型）
const timeoption = {
  shortcuts: [
    {
      text: '昨天',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '今天',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '上周',
      value: () => {
        const end = new Date();
        const start = new Date();
        const monday = start.getDay() + 6;
        const sunday = start.getDay();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * sunday);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '本周',
      value: () => {
        const end = new Date();
        const start = new Date();
        const monday = start.getDay() - 1;
        const sunday = 7 - start.getDay();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * monday);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() + 3600 * 1000 * 24 * sunday);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '上月',
      value: () => {
        const end = new Date();
        const start = new Date();
        const endday = end.getDate();
        start.setDate(1);
        start.setMonth(start.getMonth() - 1);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * endday);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '本月',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setDate(1);
        start.setHours(0, 0, 0, 0);
        end.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '去年',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setMonth(0);
        start.setDate(1);
        start.setFullYear(start.getFullYear() - 1);
        start.setHours(0, 0, 0, 0);
        end.setMonth(0);
        end.setDate(1);
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '今年',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setMonth(0);
        start.setDate(1);
        start.setHours(0, 0, 0, 0);
        end.setMonth(0);
        end.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '最近一周',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '最近一个月',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    },
    {
      text: '最近三个月',
      value: () => {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        return [start, end];
      }
    }
  ],
}

export default timeoption
